<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import FooterGuide from "@/components/FooterGuide/FooterGuide.vue";
export default {
  components: {
    FooterGuide,
  },
  name: "App",
  created() {
    if (
      typeof WeixinJSBridge == "object" &&
      typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", handleFontSize);

        document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
      }
    }

    function handleFontSize() {
      // 设置网页字体为默认大小

      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });

      // 重写设置网页字体大小的事件

      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  /* background-color: #0f1c2b; */
  /* background-image: linear-gradient(to bottom, #3374ef 1%, #f7f8fa 100%); */
}
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue